const FENCING_SVG_COLOURS = {
  'Monument': '#4A4B45',
  'Pearl White': '#FFFFFF',
  'Satin Black': '#0D0D0D'
};

const FENCING_SVG_DIVIDER_COLOURS = {
  'Monument': '#777874',
  'Pearl White': '#BDBDB8',
  'Satin Black': '#555555'
};


function getFencingSvgColour(colourName) {
  return FENCING_SVG_COLOURS[colourName] || '#4A4B45';
}

function getFencingSvgDividerColour(colourName) {
  return FENCING_SVG_DIVIDER_COLOURS[colourName] || '#777874';
}

function getFencingSvgScale(totalWidth, height) {
  const maxDrawingWidth = 360;
  const maxDrawingHeight = 200;
  const minScale = 0.15;

  const fitScale = Math.min(
    maxDrawingWidth / totalWidth,
    maxDrawingHeight / height
  );

  return Math.max(fitScale, minScale);
}

function createHorizontalDimension(startX, startY, drawingWidth, width) {
  const displayWidth = Number.isInteger(Number(width))
    ? Number(width)
    : Number(Number(width).toFixed(2));

  return `
    <line
      x1="${startX}"
      y1="${startY - 18}"
      x2="${startX + drawingWidth}"
      y2="${startY - 18}"
      stroke="#17352c"
      stroke-width="1"
    />

    <text
      x="${startX + drawingWidth / 2}"
      y="${startY - 25}"
      text-anchor="middle"
      font-size="11"
      fill="#17352c"
    >
      ${displayWidth}mm
    </text>
  `;
}

function createVerticalDimension(startX, startY, drawingHeight, height) {
  const textX = startX - 28;
  const textY = startY + drawingHeight / 2;

  const displayHeight = Number.isInteger(Number(height))
    ? Number(height)
    : Number(Number(height).toFixed(2));

  return `
    <line
      x1="${startX - 18}"
      y1="${startY}"
      x2="${startX - 18}"
      y2="${startY + drawingHeight}"
      stroke="#17352c"
      stroke-width="1"
    />

    <text
      x="${textX}"
      y="${textY}"
      text-anchor="middle"
      font-size="11"
      fill="#17352c"
      transform="rotate(-90 ${textX} ${textY})"
    >
      ${displayHeight}mm
    </text>
  `;
}

function createVerticalDimensionRight(
  endX,
  startY,
  drawingHeight,
  height
) {

  const textX =
    endX +
    28;

  const textY =
    startY +
    drawingHeight /
    2;


  const displayHeight =
    Number.isInteger(
      Number(height)
    )
      ? Number(height)
      : Number(
          Number(height).toFixed(2)
        );


  return `
    <line
      x1="${endX + 18}"
      y1="${startY}"
      x2="${endX + 18}"
      y2="${startY + drawingHeight}"
      stroke="#17352c"
      stroke-width="1"
    />

    <text
      x="${textX}"
      y="${textY}"
      text-anchor="middle"
      font-size="11"
      fill="#17352c"
      transform="rotate(-90 ${textX} ${textY})"
    >
      ${displayHeight}mm
    </text>
  `;
}


window.FencingSvgRenderer = {

  renderHorizontalSlat: function (
    container,
    totalWidth,
    height,
    gap,
    slatRows,
    colour,
    addPost,
    panelCount
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    gap = Number(gap);
    slatRows = Number(slatRows);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      !Number.isFinite(gap) ||
      !Number.isFinite(slatRows) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }
    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualHeight = 65;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const fixCenterActualWidth = 25;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale(totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale;
    const slatSvgHeight = Math.max(slatActualHeight * scale, 1);
    const gapSvgHeight = gap * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const fixCenterWidth = Math.max(fixCenterActualWidth * scale, 1.5);
    const panelVisualGap = addPost
      ? postWidth
      : 6;

    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;

    const fullDrawingWidth = totalPanelDrawingWidth + totalVisualGapWidth;
    const svgWidth = Math.max(baseSvgWidth, fullDrawingWidth + 140);
    const svgHeight = Math.max( baseSvgHeight, drawingHeight + 140);
    const startX = (svgWidth - fullDrawingWidth) / 2;
    const startY = (svgHeight - drawingHeight) / 2;
    const fencingColour = getFencingSvgColour(colour);
    const dividerColour = getFencingSvgDividerColour(colour);
    const usedHeight = (slatRows * slatActualHeight) + (Math.max(0, slatRows - 1) * gap);
    const remainingHeight = Math.max( 0, height - usedHeight);
    const topOffsetSvg = (remainingHeight / 2) * scale;
    let panelsHtml = '';
    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (panelIndex * panelDrawingWidth) +
        (panelIndex * panelVisualGap);

      let slatsHtml = '';
      let firstSlatTop = null;
      let lastSlatBottom = null;

      for (
        let i = 0;
        i < slatRows;
        i++
      ) {

        const y =
          startY +
          topOffsetSvg +
          (i * (slatSvgHeight + gapSvgHeight));

        if (i === 0) {
          firstSlatTop = y;
        }

        if (i === slatRows - 1) {
          lastSlatBottom =
            y + slatSvgHeight;
        }

        slatsHtml += `
          <rect
            x="${panelStartX + railWidth}"
            y="${y}"
            width="${Math.max(
              0,
              panelDrawingWidth - (railWidth * 2)
            )}"
            height="${slatSvgHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      let fixCenterHtml = '';

      if (
        singlePanelWidth > 1500 &&
        slatRows > 0 &&
        firstSlatTop !== null &&
        lastSlatBottom !== null
      ) {

        const fixCenterX =
          panelStartX +
          (panelDrawingWidth / 2) -
          (fixCenterWidth / 2);

        const fixCenterHeight = lastSlatBottom - firstSlatTop;

        fixCenterHtml = `
          <rect
            x="${fixCenterX}"
            y="${firstSlatTop}"
            width="${fixCenterWidth}"
            height="${fixCenterHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      panelsHtml += `
        <rect
          x="${panelStartX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${panelStartX + panelDrawingWidth - railWidth}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />

        ${slatsHtml}

        ${fixCenterHtml}
      `;
    }

    let postsHtml = '';
    let postDividerHtml = '';

    if (addPost) {

      const leftPostX =
        startX - postWidth;

      postsHtml += `
        <rect
          x="${leftPostX}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />
      `;

      postDividerHtml += `
        <line
          x1="${startX}"
          y1="${startY}"
          x2="${startX}"
          y2="${startY + drawingHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      for (
        let panelIndex = 0;
        panelIndex < panelCount - 1;
        panelIndex++
      ) {

        const currentPanelStartX = startX + (panelIndex * panelDrawingWidth) + (panelIndex * panelVisualGap);
        const middlePostX = currentPanelStartX + panelDrawingWidth;

        postsHtml += `
          <rect
            x="${middlePostX}"
            y="${startY}"
            width="${postWidth}"
            height="${drawingHeight}"
            fill="${fencingColour}"
          />
        `;

        postDividerHtml += `
          <line
            x1="${middlePostX}"
            y1="${startY}"
            x2="${middlePostX}"
            y2="${startY + drawingHeight}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${middlePostX + postWidth}"
            y1="${startY}"
            x2="${middlePostX + postWidth}"
            y2="${startY + drawingHeight}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;
      }

      const rightPostX = startX + fullDrawingWidth;
      postsHtml += `
        <rect
          x="${rightPostX}"
          y="${startY}"
          width="${postWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />
      `;

      postDividerHtml += `
        <line
          x1="${rightPostX}"
          y1="${startY}"
          x2="${rightPostX}"
          y2="${startY + drawingHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        fullDrawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${postDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },


  renderVerticalSlat: function (
    container,
    totalWidth,
    height,
    gap,
    slatColumns,
    colour,
    addPost,
    panelCount
  ) {

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    gap = Number(gap);
    slatColumns = Number(slatColumns);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      !Number.isFinite(gap) ||
      !Number.isFinite(slatColumns) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualWidth = 65;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale(totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale;
    const slatSvgWidth = Math.max(slatActualWidth * scale, 1);
    const gapSvgWidth = gap * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const panelVisualGap = addPost
      ? postWidth
      : 6;

    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;

    const fullDrawingWidth = totalPanelDrawingWidth + totalVisualGapWidth;
    const verticalPostExtension = addPost
      ? postWidth * 1.5
      : 0;

    const fullDrawingHeight = addPost
      ? drawingHeight +
        (verticalPostExtension * 2)
      : drawingHeight;

    const svgWidth = Math.max(baseSvgWidth, fullDrawingWidth + 140);
    const svgHeight = Math.max(baseSvgHeight, fullDrawingHeight + 140);
    const startX = (svgWidth - fullDrawingWidth) / 2;
    const fullDrawingStartY = (svgHeight - fullDrawingHeight) / 2;
    const startY = addPost
      ? fullDrawingStartY +
        verticalPostExtension
      : fullDrawingStartY;

    const fencingColour = getFencingSvgColour(colour);
    const dividerColour = getFencingSvgDividerColour(colour);
    const usedSlatWidth = (slatColumns * slatActualWidth) + (Math.max(0, slatColumns - 1) * gap);
    const remainingSlatWidth = Math.max(0, singlePanelWidth - usedSlatWidth);
    const sideOffsetSvg = (remainingSlatWidth / 2) * scale;

    let panelsHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX =
        startX +
        (panelIndex * panelDrawingWidth) +
        (panelIndex * panelVisualGap);

      let slatsHtml = '';

      for (
        let i = 0;
        i < slatColumns;
        i++
      ) {

        const x =
          panelStartX +
          sideOffsetSvg +
          (i * (slatSvgWidth + gapSvgWidth));

        slatsHtml += `
          <rect
            x="${x}"
            y="${startY + railWidth}"
            width="${slatSvgWidth}"
            height="${Math.max(
              0,
              drawingHeight - (railWidth * 2)
            )}"
            fill="${fencingColour}"
          />
        `;
      }

      panelsHtml += `
        ${slatsHtml}

        <rect
          x="${panelStartX}"
          y="${startY}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
        />

        <rect
          x="${panelStartX}"
          y="${startY + drawingHeight - railWidth}"
          width="${panelDrawingWidth}"
          height="${railWidth}"
          fill="${fencingColour}"
        />

        <rect
          x="${panelStartX}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${panelStartX + panelDrawingWidth - railWidth}"
          y="${startY}"
          width="${railWidth}"
          height="${drawingHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${panelStartX + railWidth}"
          y1="${startY}"
          x2="${panelStartX + railWidth}"
          y2="${startY + drawingHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${panelStartX + panelDrawingWidth - railWidth}"
          y1="${startY}"
          x2="${panelStartX + panelDrawingWidth - railWidth}"
          y2="${startY + drawingHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${panelStartX}"
          y1="${startY + railWidth}"
          x2="${panelStartX + panelDrawingWidth}"
          y2="${startY + railWidth}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${panelStartX}"
          y1="${startY + drawingHeight - railWidth}"
          x2="${panelStartX + panelDrawingWidth}"
          y2="${startY + drawingHeight - railWidth}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    let postsHtml = '';

    let postDividerHtml = '';

    if (addPost) {

      const topPostY = startY - postWidth;
      const bottomPostY = startY + drawingHeight;
      const verticalPostY = startY - verticalPostExtension;
      const verticalPostHeight = drawingHeight + (verticalPostExtension * 2);

      for (
        let panelIndex = 0;
        panelIndex < panelCount;
        panelIndex++
      ) {

        const panelStartX =
          startX +
          (panelIndex * panelDrawingWidth) +
          (panelIndex * panelVisualGap);

        postsHtml += `
          <rect
            x="${panelStartX}"
            y="${topPostY}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
          />

          <rect
            x="${panelStartX}"
            y="${bottomPostY}"
            width="${panelDrawingWidth}"
            height="${postWidth}"
            fill="${fencingColour}"
          />
        `;

        postDividerHtml += `
          <line
            x1="${panelStartX}"
            y1="${startY}"
            x2="${panelStartX + panelDrawingWidth}"
            y2="${startY}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${panelStartX}"
            y1="${startY + drawingHeight}"
            x2="${panelStartX + panelDrawingWidth}"
            y2="${startY + drawingHeight}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;
      }

      const leftPostX =
        startX - postWidth;

      postsHtml += `
        <rect
          x="${leftPostX}"
          y="${verticalPostY}"
          width="${postWidth}"
          height="${verticalPostHeight}"
          fill="${fencingColour}"
        />
      `;

      postDividerHtml += `
        <line
          x1="${startX}"
          y1="${verticalPostY}"
          x2="${startX}"
          y2="${verticalPostY + verticalPostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      for (
        let panelIndex = 0;
        panelIndex < panelCount - 1;
        panelIndex++
      ) {

        const currentPanelStartX =
          startX +
          (panelIndex * panelDrawingWidth) +
          (panelIndex * panelVisualGap);

        const middlePostX =
          currentPanelStartX +
          panelDrawingWidth;

        postsHtml += `
          <rect
            x="${middlePostX}"
            y="${verticalPostY}"
            width="${postWidth}"
            height="${verticalPostHeight}"
            fill="${fencingColour}"
          />
        `;

        postDividerHtml += `
          <line
            x1="${middlePostX}"
            y1="${verticalPostY}"
            x2="${middlePostX}"
            y2="${verticalPostY + verticalPostHeight}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${middlePostX + postWidth}"
            y1="${verticalPostY}"
            x2="${middlePostX + postWidth}"
            y2="${verticalPostY + verticalPostHeight}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;
      }

      const rightPostX = startX + fullDrawingWidth;
      postsHtml += `
        <rect
          x="${rightPostX}"
          y="${verticalPostY}"
          width="${postWidth}"
          height="${verticalPostHeight}"
          fill="${fencingColour}"
        />
      `;

      postDividerHtml += `
        <line
          x1="${rightPostX}"
          y1="${verticalPostY}"
          x2="${rightPostX}"
          y2="${verticalPostY + verticalPostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const dimensionStartY = addPost
      ? startY - verticalPostExtension
      : startY;

    const dimensionHeight = addPost
      ? drawingHeight +
        (verticalPostExtension * 2)
      : drawingHeight;

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        dimensionStartY,
        fullDrawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        dimensionStartY,
        dimensionHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${panelsHtml}
        ${postsHtml}
        ${postDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },


  renderHorizontalSlatGate: function (
    container,
    totalWidth,
    height,
    gap,
    slatQuantity,
    colour,
    panelCount,
    gateOption
  ) {
    console.log(
      'NEW HORIZONTAL GATE SVG',
      {
        totalWidth: totalWidth,
        height: height,
        gap: gap,
        slatQuantity: slatQuantity,
        panelCount: panelCount,
        gateOption: gateOption
      }
    );

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    gap = Number(gap);
    slatQuantity = Number(slatQuantity);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      !Number.isFinite(gap) ||
      !Number.isFinite(slatQuantity) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualHeight = 65;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale(totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale;
    const slatSvgHeight = Math.max(slatActualHeight * scale, 1);
    const gapSvgHeight = gap * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const gateFrameWidth = postWidth + railWidth;
    const panelVisualGap = 8;
    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;

    const fullDrawingWidth = totalPanelDrawingWidth + totalVisualGapWidth;
    const showGatePost =
      gateOption === 'single_gate' ||
      gateOption === 'double_gate';

    const gatePostExtraWidth = showGatePost
      ? postWidth * 2
      : 0;

    const fullVisualDrawingWidth = fullDrawingWidth + gatePostExtraWidth;
    const svgWidth = Math.max(baseSvgWidth, fullVisualDrawingWidth + 160);
    const svgHeight = Math.max(baseSvgHeight, drawingHeight + 160);
    const startX = showGatePost
      ? (
          (
            svgWidth - fullVisualDrawingWidth
          ) /
          2
        ) +
        postWidth
      : (
          svgWidth - fullDrawingWidth
        ) /
        2;

    const startY = (svgHeight - drawingHeight) / 2;
    const fencingColour = getFencingSvgColour(colour);
    const dividerColour = getFencingSvgDividerColour(colour);
    const gateLeafQuantity = gateOption === 'double_gate'
      ? 2
      : 1;

    const slatRowsPerLeaf = Math.max(1, Math.round(slatQuantity / gateLeafQuantity));
    let gatesHtml = '';
    let gatePostsHtml = '';
    let gatePostDividerHtml = '';

    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {

      const panelStartX = startX + (panelIndex * panelDrawingWidth) + (panelIndex * panelVisualGap);
      const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;

      const totalGateLeafGap = gateLeafVisualGap * (gateLeafQuantity - 1);
      const gateLeafWidth = (panelDrawingWidth - totalGateLeafGap) / gateLeafQuantity;
      for (
        let gateLeafIndex = 0;
        gateLeafIndex < gateLeafQuantity;
        gateLeafIndex++
      ) {

        const gateLeafStartX = panelStartX + (gateLeafIndex * (gateLeafWidth + gateLeafVisualGap));
        const gateLeafEndX = gateLeafStartX + gateLeafWidth;
        const gateLeafBottomY = startY + drawingHeight;
        const postInnerLeft = gateLeafStartX + postWidth;
        const postInnerRight = gateLeafEndX - postWidth;
        const postInnerTop = startY + postWidth;
        const postInnerBottom = gateLeafBottomY - postWidth;
        const railInnerLeft = postInnerLeft + railWidth;
        const railInnerRight = postInnerRight - railWidth;
        const railInnerTop = postInnerTop + railWidth;
        const railInnerBottom = postInnerBottom - railWidth;
        const innerWidth = Math.max(
          0,
          railInnerRight - railInnerLeft
        );

        const topPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerLeft},${postInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomPost = `
          <polygon
            points="
              ${gateLeafStartX},${gateLeafBottomY}
              ${gateLeafEndX},${gateLeafBottomY}
              ${postInnerRight},${postInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${postInnerLeft},${postInnerTop}
              ${postInnerLeft},${postInnerBottom}
              ${gateLeafStartX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const rightPost = `
          <polygon
            points="
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerRight},${postInnerBottom}
              ${gateLeafEndX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const topRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerLeft},${railInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerBottom}
              ${postInnerRight},${postInnerBottom}
              ${railInnerRight},${railInnerBottom}
              ${railInnerLeft},${railInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${railInnerLeft},${railInnerTop}
              ${railInnerLeft},${railInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const rightRail = `
          <polygon
            points="
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerRight},${railInnerBottom}
              ${postInnerRight},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const postCornerDividerHtml = `
          <line
            x1="${gateLeafStartX}"
            y1="${startY}"
            x2="${postInnerLeft}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${startY}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafStartX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railCornerDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const postRailDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const availableActualHeight = Math.max(0, height - ((postActualWidth + railActualWidth) * 2));
        const maxSlatRowThatFit = Math.max(
          1, 
          Math.floor(
            (availableActualHeight + gap) /
            (slatActualHeight + gap)
          )
        );

        const visibleSlatRows = Math.min(slatRowsPerLeaf, maxSlatRowThatFit);
        const usedSlatHeight = 
          (visibleSlatRows * slatActualHeight) + 
          (
            Math.max(
              0,
              visibleSlatRows - 1
            ) * gap
          );

        const remainingHeight = Math.max(0, availableActualHeight - usedSlatHeight);
        const topRemainingHeight = remainingHeight / 2;
        const bottomRemainingHeight = remainingHeight / 2;
        const topOffsetSvg = topRemainingHeight * scale;

        let slatsHtml = '';

        for (
          let i = 0;
          i < visibleSlatRows;
          i++
        ) {

          const slatY = railInnerTop + topOffsetSvg + (i * (slatSvgHeight + gapSvgHeight));

          slatsHtml += `
            <rect
              x="${railInnerLeft}"
              y="${slatY}"
              width="${innerWidth}"
              height="${slatSvgHeight}"
              fill="${fencingColour}"
            />
          `;
        }

        gatesHtml += `
          ${slatsHtml}
          ${topPost}
          ${bottomPost}
          ${leftPost}
          ${rightPost}
          ${topRail}
          ${bottomRail}
          ${leftRail}
          ${rightRail}
          ${postRailDividerHtml}
          ${postCornerDividerHtml}
          ${railCornerDividerHtml}
        `;
      }
    }

    if (showGatePost) {

      const gatePostExtension = postWidth * 0.5;
      const gatePostY = startY - gatePostExtension;
      const gatePostHeight = drawingHeight + (gatePostExtension * 2);
      const leftGatePostX = startX - postWidth;
      const rightGatePostX = startX + fullDrawingWidth;

      gatePostsHtml += `
        <rect 
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${startX}"
          y1="${gatePostY}"
          x2="${startX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        fullDrawingWidth,
        totalWidth
      );
    
    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >

        ${gatesHtml}
        ${gatePostsHtml}
        ${gatePostDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },

  renderVerticalSlatGate: function (
    container,
    totalWidth,
    height,
    gap,
    slatQuantity,
    colour,
    panelCount,
    gateOption
  ) {
    console.log(
      'NEW VERTICAL GATE SVG',
      {
        totalWidth: totalWidth,
        height: height,
        gap: gap,
        slatQuantity: slatQuantity,
        panelCount: panelCount,
        gateOption: gateOption
      }
    );

    if (!container) {
      return;
    }

    totalWidth = Number(totalWidth);
    height = Number(height);
    gap = Number(gap);
    slatQuantity = Number(slatQuantity);
    panelCount = Number(panelCount) || 1;

    if (
      !Number.isFinite(totalWidth) ||
      !Number.isFinite(height) ||
      !Number.isFinite(gap) ||
      !Number.isFinite(slatQuantity) ||
      totalWidth <= 0 ||
      height <= 0 ||
      panelCount <= 0
    ) {
      return;
    }

    const baseSvgWidth = 500;
    const previewBoxHeight = container.clientHeight || 320;
    const baseSvgHeight = Math.max(320, previewBoxHeight);
    const slatActualWidth = 65;
    const railActualWidth = 26;
    const postActualWidth = 50;
    const singlePanelWidth = totalWidth / panelCount;
    const scale = getFencingSvgScale(totalWidth, height);
    const totalPanelDrawingWidth = totalWidth * scale;
    const drawingHeight = height * scale;
    const panelDrawingWidth = singlePanelWidth * scale; 
    const slatSvgWidth = Math.max(slatActualWidth * scale, 1);
    const gapSvgWidth = gap * scale;
    const railWidth = Math.max(railActualWidth * scale, 1.5);
    const postWidth = Math.max(postActualWidth * scale, 2.5);
    const gateFrameWidth = postWidth + railWidth;
    const panelVisualGap = 8;
    const totalVisualGapWidth = panelCount > 1
      ? panelVisualGap * (panelCount - 1)
      : 0;
    
    const fullDrawingWidth = totalPanelDrawingWidth + totalVisualGapWidth;
    const showGatePost = gateOption === 'single_gate' || gateOption === 'double_gate';
    const gatePostExtraWidth = showGatePost
      ? postWidth * 2
      : 0;

    const fullVisualDrawingWidth = fullDrawingWidth + gatePostExtraWidth;
    const gatePostExtension = showGatePost
      ? postWidth * 0.5
      : 0;
    
    const fullVisualDrawingHeight = drawingHeight + (gatePostExtension * 2);
    const svgWidth = Math.max(baseSvgWidth, fullVisualDrawingWidth + 160);
    const svgHeight = Math.max(baseSvgHeight, fullVisualDrawingHeight + 160);
    const startX = showGatePost 
      ? (
          (
            svgWidth - fullVisualDrawingWidth
          ) /
          2
        ) +
        postWidth
      : (
          svgWidth - fullDrawingWidth
        ) /
        2;
    const fullDrawingStartY = (svgHeight - fullVisualDrawingHeight) / 2;
    const startY = showGatePost
      ? fullDrawingStartY +
        gatePostExtension
      : (
          svgHeight - drawingHeight
        ) /
        2;
    const fencingColour = getFencingSvgColour(colour);
    const dividerColour = getFencingSvgDividerColour(colour);
    const gateLeafQuantity = gateOption === 'double_gate'
      ? 2
      : 1;
    const slatColumnsPerLeaf = Math.max(
      1,
      Math.round(
        slatQuantity /
        gateLeafQuantity
      )
    );
    let gatesHtml = '';
    let gatePostsHtml = '';
    let gatePostDividerHtml = '';
    for (
      let panelIndex = 0;
      panelIndex < panelCount;
      panelIndex++
    ) {
      const panelStartX = startX + (panelIndex * panelDrawingWidth) + (panelIndex * panelVisualGap);
      const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;
      
      const totalGateLeafGap = gateLeafVisualGap * (gateLeafQuantity - 1);
      const gateLeafWidth = (panelDrawingWidth - totalGateLeafGap) / gateLeafQuantity;

      for (
        let gateLeafIndex = 0;
        gateLeafIndex < gateLeafQuantity ;
        gateLeafIndex++
      ) {
        const gateLeafStartX = 
          panelStartX + 
          (
            gateLeafIndex *
            (
              gateLeafWidth +
              gateLeafVisualGap
            )
          );
        const gateLeafEndX = gateLeafStartX + gateLeafWidth;
        const gateLeafBottomY = startY + drawingHeight;
        const postInnerLeft = gateLeafStartX + postWidth;
        const postInnerRight = gateLeafEndX - postWidth;
        const postInnerTop = startY + postWidth;
        const postInnerBottom = gateLeafBottomY - postWidth;
        const railInnerLeft = postInnerLeft + railWidth;
        const railInnerRight = postInnerRight - railWidth;
        const railInnerTop = postInnerTop + railWidth;
        const railInnerBottom = postInnerBottom - railWidth;
        const innerWidth = Math.max(
          0,
          railInnerRight - railInnerLeft
        );
        const innerHeight = Math.max(
          0,
          railInnerBottom - railInnerTop
        );

        const topPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerLeft},${postInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomPost = `
          <polygon
            points="
              ${gateLeafStartX},${gateLeafBottomY}
              ${gateLeafEndX},${gateLeafBottomY}
              ${postInnerRight},${postInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftPost = `
          <polygon
            points="
              ${gateLeafStartX},${startY}
              ${postInnerLeft},${postInnerTop}
              ${postInnerLeft},${postInnerBottom}
              ${gateLeafStartX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const rightPost = `
          <polygon
            points="
              ${gateLeafEndX},${startY}
              ${postInnerRight},${postInnerTop}
              ${postInnerRight},${postInnerBottom}
              ${gateLeafEndX},${gateLeafBottomY}
            "
            fill="${fencingColour}"
          />
        `;

        const topRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerLeft},${railInnerTop}
            "
            fill="${fencingColour}"
          />
        `;

        const bottomRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerBottom}
              ${postInnerRight},${postInnerBottom}
              ${railInnerRight},${railInnerBottom}
              ${railInnerLeft},${railInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const leftRail = `
          <polygon
            points="
              ${postInnerLeft},${postInnerTop}
              ${railInnerLeft},${railInnerTop}
              ${railInnerLeft},${railInnerBottom}
              ${postInnerLeft},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const rightRail = `
          <polygon
            points="
              ${postInnerRight},${postInnerTop}
              ${railInnerRight},${railInnerTop}
              ${railInnerRight},${railInnerBottom}
              ${postInnerRight},${postInnerBottom}
            "
            fill="${fencingColour}"
          />
        `;

        const postCornerDividerHtml = `
          <line
            x1="${gateLeafStartX}"
            y1="${startY}"
            x2="${postInnerLeft}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
          
          <line
            x1="${gateLeafEndX}"
            y1="${startY}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

           <line
            x1="${gateLeafStartX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${gateLeafEndX}"
            y1="${gateLeafBottomY}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const railCornerDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${railInnerLeft}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${railInnerRight}"
            y2="${railInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${railInnerLeft}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

           <line
            x1="${postInnerRight}"
            y1="${postInnerBottom}"
            x2="${railInnerRight}"
            y2="${railInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;

        const postRailDividerHtml = `
          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerTop}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerBottom}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerLeft}"
            y1="${postInnerTop}"
            x2="${postInnerLeft}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${postInnerRight}"
            y1="${postInnerTop}"
            x2="${postInnerRight}"
            y2="${postInnerBottom}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;
        const availableActualWidth = Math.max(
          0,
          singlePanelWidth /
          gateLeafQuantity -
          ((postActualWidth + railActualWidth) * 2)
        );

        const maxSlatColumnsThatFit = Math.max(
          1,
          Math.floor(
            (availableActualWidth + gap) /
            (slatActualWidth + gap)
          )
        );

        const visibleSlatColumns = Math.min(
          slatColumnsPerLeaf,
          maxSlatColumnsThatFit
        );

        const usedSlatWidth =
          (visibleSlatColumns * slatActualWidth) +
          (
            Math.max(
              0,
              visibleSlatColumns - 1
            ) * gap
          );

        const remainingWidth = Math.max(
          0,
          availableActualWidth - usedSlatWidth
        );
        const leftRemainingWidth = remainingWidth / 2;
        const rightRemainingWidth = remainingWidth / 2;
        const sideOffsetSvg = leftRemainingWidth * scale;
        let slatsHtml = '';

         for (
          let i = 0;
          i < visibleSlatColumns;
          i++
        ) {

          const slatX =
            railInnerLeft +
            sideOffsetSvg +
            (
              i *
              (
                slatSvgWidth +
                gapSvgWidth
              )
            );

          slatsHtml += `
            <rect
              x="${slatX}"
              y="${railInnerTop}"
              width="${slatSvgWidth}"
              height="${innerHeight}"
              fill="${fencingColour}"
            />
          `;
        }

        gatesHtml += `
          ${slatsHtml}
          ${topPost}
          ${bottomPost}
          ${leftPost}
          ${rightPost}
          ${topRail}
          ${bottomRail}
          ${leftRail}
          ${rightRail}
          ${postRailDividerHtml}
          ${postCornerDividerHtml}
          ${railCornerDividerHtml}
        `;
      }
    }

    if (showGatePost) {
      const gatePostY = startY - gatePostExtension;
      const gatePostHeight = drawingHeight + (gatePostExtension * 2);
      const leftGatePostX = startX - postWidth;
      const rightGatePostX = startX + fullDrawingWidth;

      gatePostsHtml += `
        <rect
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${startX}"
          y1="${gatePostY}"
          x2="${startX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    const widthDimensionHtml =
      createHorizontalDimension(
        startX,
        startY,
        fullDrawingWidth,
        totalWidth
      );

    const heightDimensionHtml =
      createVerticalDimension(
        startX,
        startY,
        drawingHeight,
        height
      );

    container.innerHTML = `
      <svg
        width="${svgWidth}"
        height="${svgHeight}"
        viewBox="0 0 ${svgWidth} ${svgHeight}"
        preserveAspectRatio="xMidYMid meet"
        xmlns="http://www.w3.org/2000/svg"
        style="display:block; margin:0 auto;"
      >
        ${gatesHtml}
        ${gatePostsHtml}
        ${gatePostDividerHtml}
        ${widthDimensionHtml}
        ${heightDimensionHtml}

      </svg>
    `;
  },

  renderHorizontalSlatGatePanel: function (
    container,
    details,
    colour,
    gateOption
  ) {

  console.log(
    'NEW HORIZONTAL GATE PANEL SVG',
    {
      details: details,
      colour: colour,
      gateOption: gateOption
    }
  );

  if (
    !container ||
    !Array.isArray(details) ||
    details.length === 0
  ) {
    return;
  }

  const gateDetail = details[0];
  const panelDetails = details.slice(1);

  if (!gateDetail) {
    return;
  }

  const gateWidth = Number(gateDetail.width);
  const gateHeight = Number(gateDetail.height);
  const gateGap = Number(gateDetail.gap);
  const gateQuantity = Number(gateDetail.quantity) || 1;
  const gateSlatQuantity = Number(gateDetail.productCount);

  if (
    !Number.isFinite(gateWidth) ||
    !Number.isFinite(gateHeight) ||
    !Number.isFinite(gateGap) ||
    !Number.isFinite(gateSlatQuantity) ||
    gateWidth <= 0 ||
    gateHeight <= 0 ||
    gateQuantity <= 0
  ) {
    return;
  }

  const baseSvgWidth = 500;
  const previewBoxHeight = container.clientHeight || 320;
  const baseSvgHeight = Math.max(320, previewBoxHeight);
  const slatActualHeight = 65;
  const railActualWidth = 26;
  const postActualWidth = 50;
  const fixCenterActualWidth = 25;
  const panelVisualGapNoPost = 6;
  const gateLeafQuantity =
    gateOption === 'double_gate'
      ? 2
      : 1;

  const showGatePost =
    gateOption === 'single_gate' ||
    gateOption === 'double_gate';

  let totalActualWidth = gateWidth * gateQuantity;
  let maximumActualHeight = gateHeight;

  panelDetails.forEach(function (panel) {

    const panelWidth = Number(panel.width);
    const panelHeight = Number(panel.height);
    const panelQuantity = Number(panel.quantity) || 1;

    if (
      !Number.isFinite(panelWidth) ||
      !Number.isFinite(panelHeight) ||
      panelWidth <= 0 ||
      panelHeight <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    totalActualWidth += panelWidth * panelQuantity;

    if (panel.addPost) {

      totalActualWidth +=
        postActualWidth *
        (
          panelQuantity +
          1
        );

    } else if (
      panelQuantity > 1
    ) {

      totalActualWidth +=
        panelVisualGapNoPost *
        (
          panelQuantity -
          1
        );
    }

    maximumActualHeight = Math.max(maximumActualHeight, panelHeight);
  });

  if (showGatePost) {
    totalActualWidth += postActualWidth * gateQuantity * 2;
  }

  const groupVisualGapActual = 40;
  const groupCount = 1 + panelDetails.length;

  if (groupCount > 1) {

    totalActualWidth +=
      groupVisualGapActual *
      (
        groupCount -
        1
      );
  }

  const scale = getFencingSvgScale(totalActualWidth, maximumActualHeight);
  const slatSvgHeight = Math.max(slatActualHeight * scale, 1);
  const gateGapSvgHeight = gateGap * scale;
  const railWidth = Math.max(railActualWidth * scale, 1.5);
  const postWidth = Math.max(postActualWidth * scale, 2.5);
  const fixCenterWidth = Math.max(fixCenterActualWidth * scale, 1.5);
  const groupVisualGap = groupVisualGapActual * scale;
  const gateDrawingWidth = gateWidth * gateQuantity * scale;
  const gateDrawingHeight = gateHeight * scale;

  const gatePostExtraWidth = showGatePost
      ? postWidth * gateQuantity * 2
      : 0;

  let panelGroupsDrawingWidth = 0;
  panelDetails.forEach(function (panel) {

    const panelWidth = Number(panel.width);
    const panelQuantity = Number(panel.quantity) || 1;

    if (
      !Number.isFinite(panelWidth) ||
      panelWidth <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    const panelDrawingWidth = panelWidth * scale;
    panelGroupsDrawingWidth += panelDrawingWidth * panelQuantity;

    if (panel.addPost) { panelGroupsDrawingWidth += postWidth *
        (
          panelQuantity + 1
        );

    } else if (
      panelQuantity > 1
    ) {

      panelGroupsDrawingWidth +=
        panelVisualGapNoPost *
        (
          panelQuantity -
          1
        );
    }
  });

  const totalGroupGapWidth = panelDetails.length > 0
      ? groupVisualGap * panelDetails.length
      : 0;

  const fullDrawingWidth =
    gateDrawingWidth +
    gatePostExtraWidth +
    panelGroupsDrawingWidth +
    totalGroupGapWidth;

  const gatePostExtension =showGatePost
      ? postWidth * 0.5
      : 0;

  let maximumDrawingHeight = gateDrawingHeight + (gatePostExtension * 2);
  panelDetails.forEach(function (panel) {

    const panelHeight = Number(panel.height);

    if (
      !Number.isFinite(panelHeight) ||
      panelHeight <= 0
    ) {
      return;
    }

    maximumDrawingHeight = Math.max(
      maximumDrawingHeight,
      panelHeight *
      scale
    );
  });

  const svgWidth = Math.max(baseSvgWidth, fullDrawingWidth + 180);
  const svgHeight = Math.max(baseSvgHeight, maximumDrawingHeight + 180);
  const startX = (svgWidth - fullDrawingWidth) / 2;
  const fullDrawingStartY = (svgHeight - maximumDrawingHeight) / 2;
  const fencingColour = getFencingSvgColour(colour);
  const dividerColour = getFencingSvgDividerColour(colour);
  let gateHtml = '';
  let gatePostsHtml = '';
  let gatePostDividerHtml = '';
  let panelsHtml = '';
  let panelPostsHtml = '';
  let panelPostDividerHtml = '';
  let dimensionsHtml = '';
  let currentX =startX;

  for (
    let gateIndex = 0;
    gateIndex < gateQuantity;
    gateIndex++
  ) {

    const singleGateDrawingWidth = gateWidth * scale;
    const gateBodyStartX = showGatePost
        ? currentX + postWidth
        : currentX;

    const gateStartY = fullDrawingStartY + gatePostExtension;
    const gateBottomY = gateStartY + gateDrawingHeight;
    const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;

    const totalGateLeafGap = gateLeafVisualGap * (gateLeafQuantity - 1);
    const gateLeafWidth =(singleGateDrawingWidth - totalGateLeafGap)/gateLeafQuantity;
    const slatRowsPerLeaf =Math.max( 1, Math.round(gateSlatQuantity / gateLeafQuantity));
    for (
      let gateLeafIndex = 0;
      gateLeafIndex < gateLeafQuantity;
      gateLeafIndex++
    ) {

      const gateLeafStartX = gateBodyStartX + (gateLeafIndex * (gateLeafWidth + gateLeafVisualGap));
      const gateLeafEndX = gateLeafStartX + gateLeafWidth;
      const postInnerLeft = gateLeafStartX + postWidth;
      const postInnerRight = gateLeafEndX - postWidth;
      const postInnerTop = gateStartY + postWidth;
      const postInnerBottom = gateBottomY - postWidth;
      const railInnerLeft = postInnerLeft + railWidth;
      const railInnerRight = postInnerRight - railWidth;
      const railInnerTop = postInnerTop + railWidth;
      const railInnerBottom = postInnerBottom - railWidth;
      const innerWidth = Math.max(0, railInnerRight - railInnerLeft );
      const topPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateStartY}
            ${gateLeafEndX},${gateStartY}
            ${postInnerRight},${postInnerTop}
            ${postInnerLeft},${postInnerTop}
          "
          fill="${fencingColour}"
        />
      `;

      const bottomPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateBottomY}
            ${gateLeafEndX},${gateBottomY}
            ${postInnerRight},${postInnerBottom}
            ${postInnerLeft},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const leftPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateStartY}
            ${postInnerLeft},${postInnerTop}
            ${postInnerLeft},${postInnerBottom}
            ${gateLeafStartX},${gateBottomY}
          "
          fill="${fencingColour}"
        />
      `;

      const rightPost = `
        <polygon
          points="
            ${gateLeafEndX},${gateStartY}
            ${postInnerRight},${postInnerTop}
            ${postInnerRight},${postInnerBottom}
            ${gateLeafEndX},${gateBottomY}
          "
          fill="${fencingColour}"
        />
      `;

      const topRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerTop}
            ${postInnerRight},${postInnerTop}
            ${railInnerRight},${railInnerTop}
            ${railInnerLeft},${railInnerTop}
          "
          fill="${fencingColour}"
        />
      `;

      const bottomRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerBottom}
            ${postInnerRight},${postInnerBottom}
            ${railInnerRight},${railInnerBottom}
            ${railInnerLeft},${railInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const leftRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerTop}
            ${railInnerLeft},${railInnerTop}
            ${railInnerLeft},${railInnerBottom}
            ${postInnerLeft},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const rightRail = `
        <polygon
          points="
            ${postInnerRight},${postInnerTop}
            ${railInnerRight},${railInnerTop}
            ${railInnerRight},${railInnerBottom}
            ${postInnerRight},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const postCornerDividerHtml = `
        <line
          x1="${gateLeafStartX}"
          y1="${gateStartY}"
          x2="${postInnerLeft}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafEndX}"
          y1="${gateStartY}"
          x2="${postInnerRight}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafStartX}"
          y1="${gateBottomY}"
          x2="${postInnerLeft}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafEndX}"
          y1="${gateBottomY}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const railCornerDividerHtml = `
        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${railInnerLeft}"
          y2="${railInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerTop}"
          x2="${railInnerRight}"
          y2="${railInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerBottom}"
          x2="${railInnerLeft}"
          y2="${railInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerBottom}"
          x2="${railInnerRight}"
          y2="${railInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const postRailDividerHtml = `
        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${postInnerRight}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerBottom}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${postInnerLeft}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerTop}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const availableActualHeight =
        Math.max(
          0,
          gateHeight -
          (
            (
              postActualWidth + railActualWidth
            ) *
            2
          )
        );

      const maxSlatRowsThatFit =
        Math.max(
          1,
          Math.floor(
            (
              availableActualHeight + gateGap
            ) /
            (
              slatActualHeight + gateGap
            )
          )
        );

      const visibleSlatRows = Math.min(slatRowsPerLeaf, maxSlatRowsThatFit);
      const usedSlatHeight = (visibleSlatRows * slatActualHeight) + (Math.max(0, visibleSlatRows - 1) * gateGap);
      const remainingHeight = Math.max( 0, availableActualHeight - usedSlatHeight);
      const topRemainingHeight = remainingHeight / 2;
      const topOffsetSvg = topRemainingHeight * scale;
      let slatsHtml = '';

      for (
        let i = 0;
        i < visibleSlatRows;
        i++
      ) {

        const slatY = railInnerTop + topOffsetSvg +
          (
            i *
            (
              slatSvgHeight + gateGapSvgHeight
            )
          );

        slatsHtml += `
          <rect
            x="${railInnerLeft}"
            y="${slatY}"
            width="${innerWidth}"
            height="${slatSvgHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      gateHtml += `
        ${slatsHtml}
        ${topPost}
        ${bottomPost}
        ${leftPost}
        ${rightPost}
        ${topRail}
        ${bottomRail}
        ${leftRail}
        ${rightRail}
        ${postRailDividerHtml}
        ${postCornerDividerHtml}
        ${railCornerDividerHtml}
      `;
    }

    if (showGatePost) {

      const gatePostY = gateStartY - gatePostExtension;
      const gatePostHeight = gateDrawingHeight + (gatePostExtension * 2);
      const leftGatePostX = gateBodyStartX - postWidth;
      const rightGatePostX = gateBodyStartX + singleGateDrawingWidth;

      gatePostsHtml += `
        <rect
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${gateBodyStartX}"
          y1="${gatePostY}"
          x2="${gateBodyStartX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    dimensionsHtml +=
      createHorizontalDimension(
        gateBodyStartX,
        gateStartY,
        singleGateDrawingWidth,
        gateWidth
      );

    dimensionsHtml +=
      createVerticalDimension(
        gateBodyStartX,
        gateStartY,
        gateDrawingHeight,
        gateHeight
      );

    currentX += singleGateDrawingWidth;

    if (showGatePost) {
      currentX += postWidth * 2;
    }

    if ( gateIndex < gateQuantity - 1 )
     {
      currentX += groupVisualGap;
    }
  }

  if (panelDetails.length > 0) {

    currentX += groupVisualGap;
  }

  panelDetails.forEach(function (
    panel, panelGroupIndex
  ) {

    const panelWidth = Number(panel.width);
    const panelHeight = Number(panel.height);
    const panelQuantity = Number(panel.quantity) || 1;
    const panelGap = Number(panel.gap);
    const panelSlatRows = Number(panel.productCount);
    const addPost = panel.addPost === true;

    if (
      !Number.isFinite(panelWidth) ||
      !Number.isFinite(panelHeight) ||
      !Number.isFinite(panelGap) ||
      !Number.isFinite(panelSlatRows) ||
      panelWidth <= 0 ||
      panelHeight <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    const panelDrawingWidth = panelWidth * scale;
    const panelDrawingHeight = panelHeight * scale;
    const panelGapSvgHeight = panelGap * scale;
    const panelVisualGap = addPost
        ? postWidth
        : panelVisualGapNoPost;

    const panelGroupBodyWidth = panelDrawingWidth * panelQuantity;
    const panelGroupVisualGapWidth =
      panelQuantity > 1
        ? panelVisualGap *
          (
            panelQuantity -
            1
          )
        : 0;

    const panelGroupSidePostWidth = addPost
        ? postWidth * 2
        : 0;

    const panelGroupFullWidth =
      panelGroupBodyWidth +
      panelGroupVisualGapWidth +
      panelGroupSidePostWidth;

    const panelStartY = fullDrawingStartY + (maximumDrawingHeight - panelDrawingHeight) / 2;
    const usedHeight = (panelSlatRows * slatActualHeight) + ( Math.max(0, panelSlatRows - 1) *panelGap);
    const remainingHeight = Math.max(0, panelHeight - usedHeight);
    const topOffsetSvg =(remainingHeight /  2) * scale;
    const panelGroupStartX = currentX;

    for (
      let panelIndex = 0;
      panelIndex < panelQuantity;
      panelIndex++
    ) {

      const currentPanelStartX =
        panelGroupStartX +
        (
          addPost
            ? postWidth
            : 0
        ) +
        (
          panelIndex *
          (
            panelDrawingWidth + panelVisualGap
          )
        );

      let slatsHtml = '';
      let firstSlatTop = null;
      let lastSlatBottom = null;

      for (
        let i = 0;
        i < panelSlatRows;
        i++
      ) {

        const slatY =
          panelStartY +
          topOffsetSvg +
          (
            i *
            (
              slatSvgHeight +panelGapSvgHeight
            )
          );

        if (i === 0) {
          firstSlatTop = slatY;
        }

        if (
          i === panelSlatRows - 1
        ) {
          lastSlatBottom = slatY + slatSvgHeight;
        }

        slatsHtml += `
          <rect
            x="${currentPanelStartX + railWidth}"
            y="${slatY}"
            width="${Math.max(
              0,
              panelDrawingWidth -
              (
                railWidth *  2
              )
            )}"
            height="${slatSvgHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      let fixCenterHtml = '';

      if (
        panelWidth > 1500 &&
        panelSlatRows > 0 &&
        firstSlatTop !== null &&
        lastSlatBottom !== null
      ) {

        const fixCenterX = currentPanelStartX + (panelDrawingWidth / 2) - (fixCenterWidth / 2);
        const fixCenterHeight = lastSlatBottom - firstSlatTop;

        fixCenterHtml = `
          <rect
            x="${fixCenterX}"
            y="${firstSlatTop}"
            width="${fixCenterWidth}"
            height="${fixCenterHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      panelsHtml += `
        <rect
          x="${currentPanelStartX}"
          y="${panelStartY}"
          width="${railWidth}"
          height="${panelDrawingHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${currentPanelStartX + panelDrawingWidth - railWidth}"
          y="${panelStartY}"
          width="${railWidth}"
          height="${panelDrawingHeight}"
          fill="${fencingColour}"
        />

        ${slatsHtml}
        ${fixCenterHtml}
      `;
    }

    if (addPost) {

      for (
        let postIndex = 0;
        postIndex <= panelQuantity;
        postIndex++
      ) {

        const panelPostX =
          postIndex === 0
            ? panelGroupStartX
            : panelGroupStartX +
              postWidth +
              (
                postIndex *
                panelDrawingWidth
              ) +
              (
                (
                  postIndex -
                  1
                ) *
                postWidth
              );

        panelPostsHtml += `
          <rect
            x="${panelPostX}"
            y="${panelStartY}"
            width="${postWidth}"
            height="${panelDrawingHeight}"
            fill="${fencingColour}"
          />
        `;

        if (postIndex === 0) {

          panelPostDividerHtml += `
            <line
              x1="${panelPostX + postWidth}"
              y1="${panelStartY}"
              x2="${panelPostX + postWidth}"
              y2="${panelStartY + panelDrawingHeight}"
              stroke="${dividerColour}"
              stroke-width="1"
            />
          `;

        } else if (
          postIndex === panelQuantity
        ) {

          panelPostDividerHtml += `
            <line
              x1="${panelPostX}"
              y1="${panelStartY}"
              x2="${panelPostX}"
              y2="${panelStartY + panelDrawingHeight}"
              stroke="${dividerColour}"
              stroke-width="1"
            />
          `;

        } else {

          panelPostDividerHtml += `
            <line
              x1="${panelPostX}"
              y1="${panelStartY}"
              x2="${panelPostX}"
              y2="${panelStartY + panelDrawingHeight}"
              stroke="${dividerColour}"
              stroke-width="1"
            />

            <line
              x1="${panelPostX + postWidth}"
              y1="${panelStartY}"
              x2="${panelPostX + postWidth}"
              y2="${panelStartY + panelDrawingHeight}"
              stroke="${dividerColour}"
              stroke-width="1"
            />
          `;
        }
      }
    }

    const panelDimensionStartX = addPost
        ? panelGroupStartX + postWidth
        : panelGroupStartX;

    const panelDimensionWidth = panelGroupBodyWidth + panelGroupVisualGapWidth;
    const panelDimensionActualWidth = panelWidth * panelQuantity;
    const panelDimensionEndX =  panelGroupStartX +  panelGroupFullWidth;

    dimensionsHtml +=
      createHorizontalDimension(
        panelDimensionStartX,
        panelStartY,
        panelDimensionWidth,
        panelDimensionActualWidth
      );

    dimensionsHtml +=
      createVerticalDimensionRight(
        panelDimensionEndX,
        panelStartY,
        panelDrawingHeight,
        panelHeight
      );

    currentX += panelGroupFullWidth;
    if (
      panelGroupIndex < panelDetails.length - 1
    ) {
      currentX += groupVisualGap;
    }
  });

  container.innerHTML = `
    <svg
      width="${svgWidth}"
      height="${svgHeight}"
      viewBox="0 0 ${svgWidth} ${svgHeight}"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      style="display:block; margin:0 auto;"
    >

      ${gateHtml}
      ${gatePostsHtml}
      ${gatePostDividerHtml}
      ${panelsHtml}
      ${panelPostsHtml}
      ${panelPostDividerHtml}
      ${dimensionsHtml}

    </svg>
  `;
},

renderVerticalSlatGatePanel: function (
  container,
  details,
  colour,
  gateOption
) {

  console.log(
    'NEW VERTICAL GATE PANEL SVG',
    {
      details: details,
      colour: colour,
      gateOption: gateOption
    }
  );

  if (
    !container ||
    !Array.isArray(details) ||
    details.length === 0
  ) {
    return;
  }

  const gateDetail = details[0];
  const panelDetails = details.slice(1);

  if (!gateDetail) {
    return;
  }

  const gateWidth = Number(gateDetail.width);
  const gateHeight = Number(gateDetail.height);
  const gateGap = Number(gateDetail.gap);
  const gateQuantity = Number(gateDetail.quantity) || 1;
  const gateSlatQuantity = Number(gateDetail.productCount);

  if (
    !Number.isFinite(gateWidth) ||
    !Number.isFinite(gateHeight) ||
    !Number.isFinite(gateGap) ||
    !Number.isFinite(gateSlatQuantity) ||
    gateWidth <= 0 ||
    gateHeight <= 0 ||
    gateQuantity <= 0
  ) {
    return;
  }

  const baseSvgWidth = 500;
  const previewBoxHeight = container.clientHeight || 320;
  const baseSvgHeight = Math.max(320, previewBoxHeight);
  const slatActualWidth = 65;
  const railActualWidth = 26;
  const postActualWidth = 50;
  const panelVisualGapNoPost = 6;
  const groupVisualGapActual = 40;

  const gateLeafQuantity =
    gateOption === 'double_gate'
      ? 2
      : 1;

  const showGatePost =
    gateOption === 'single_gate' ||
    gateOption === 'double_gate';

  let totalActualWidth =
    gateWidth *
    gateQuantity;

  let maximumActualHeight =
    gateHeight;

  panelDetails.forEach(function (panel) {

    const panelWidth = Number(panel.width);
    const panelHeight = Number(panel.height);
    const panelQuantity = Number(panel.quantity) || 1;

    if (
      !Number.isFinite(panelWidth) ||
      !Number.isFinite(panelHeight) ||
      panelWidth <= 0 ||
      panelHeight <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    totalActualWidth +=
      panelWidth *
      panelQuantity;

    if (
      panelQuantity > 1
    ) {

      totalActualWidth +=
        panelVisualGapNoPost *
        (
          panelQuantity -
          1
        );
    }

    maximumActualHeight =
      Math.max(
        maximumActualHeight,
        panelHeight
      );
  });

  if (showGatePost) {

    totalActualWidth +=
      postActualWidth *
      gateQuantity *
      2;
  }

  const groupCount = 1 + panelDetails.length;

  if (
    groupCount > 1
  ) {

    totalActualWidth +=
      groupVisualGapActual *
      (
        groupCount -
        1
      );
  }

  const scale =
    getFencingSvgScale(
      totalActualWidth,
      maximumActualHeight
    );

  const slatSvgWidth =
    Math.max(
      slatActualWidth *
      scale,
      1
    );

  const gateGapSvgWidth = gateGap * scale;
  const railWidth =
    Math.max(
      railActualWidth *
      scale,
      1.5
    );

  const postWidth =
    Math.max(
      postActualWidth *
      scale,
      2.5
    );

  const groupVisualGap = groupVisualGapActual * scale;
  const gateDrawingWidth = gateWidth * gateQuantity * scale;
  const gateDrawingHeight = gateHeight * scale;
  const gatePostExtraWidth = showGatePost
      ? postWidth * gateQuantity * 2
      : 0;

  let panelGroupsDrawingWidth = 0;

  panelDetails.forEach(function (panel) {

    const panelWidth = Number(panel.width);
    const panelQuantity = Number(panel.quantity) || 1;

    if (
      !Number.isFinite(panelWidth) ||
      panelWidth <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    const panelDrawingWidth =
      panelWidth *
      scale;

    panelGroupsDrawingWidth +=
      panelDrawingWidth *
      panelQuantity;

    if (
      panelQuantity > 1
    ) {

      panelGroupsDrawingWidth +=
        panelVisualGapNoPost *
        (
          panelQuantity -
          1
        );
    }
  });

  const totalGroupGapWidth =
    panelDetails.length > 0
      ? groupVisualGap *
        panelDetails.length
      : 0;

  const fullDrawingWidth =
    gateDrawingWidth +
    gatePostExtraWidth +
    panelGroupsDrawingWidth +
    totalGroupGapWidth;

  const gatePostExtension = showGatePost
      ? postWidth * 0.5
      : 0;

  let maximumDrawingHeight =
    gateDrawingHeight +
    (
      gatePostExtension *
      2
    );

  panelDetails.forEach(function (panel) {

    const panelHeight = Number(panel.height);

    if (
      !Number.isFinite(panelHeight) ||
      panelHeight <= 0
    ) {
      return;
    }

    const panelDrawingHeight =
      panelHeight *
      scale;

    maximumDrawingHeight =
      Math.max(
        maximumDrawingHeight,
        panelDrawingHeight
      );
  });

  const svgWidth =
    Math.max(
      baseSvgWidth,
      fullDrawingWidth +
      180
    );

  const svgHeight =
    Math.max(
      baseSvgHeight,
      maximumDrawingHeight +
      180
    );

  const startX = (svgWidth - fullDrawingWidth) / 2;
  const fullDrawingStartY = (svgHeight - maximumDrawingHeight) /2;
  const fencingColour = getFencingSvgColour(colour);
  const dividerColour = getFencingSvgDividerColour(colour);

  let gateHtml = '';
  let gatePostsHtml = '';
  let gatePostDividerHtml = '';
  let panelsHtml = '';
  let panelPostsHtml = '';
  let panelPostDividerHtml = '';
  let dimensionsHtml = '';
  let currentX = startX;

  for (
    let gateIndex = 0;
    gateIndex < gateQuantity;
    gateIndex++
  ) {

    const singleGateDrawingWidth =gateWidth * scale;

    const gateBodyStartX = showGatePost
        ? currentX + postWidth
        : currentX;

    const gateStartY =
      fullDrawingStartY +
      (
        maximumDrawingHeight -
        gateDrawingHeight
      ) /
      2;

    const gateBottomY = gateStartY + gateDrawingHeight;
    const gateLeafVisualGap = gateLeafQuantity === 2
        ? 5
        : 0;

    const totalGateLeafGap =
      gateLeafVisualGap *
      (
        gateLeafQuantity -
        1
      );

    const gateLeafWidth =
      (
        singleGateDrawingWidth -
        totalGateLeafGap
      ) /
      gateLeafQuantity;

    const slatColumnsPerLeaf =
      Math.max(
        1,
        Math.round(
          gateSlatQuantity /
          gateLeafQuantity
        )
      );

    for (
      let gateLeafIndex = 0;
      gateLeafIndex < gateLeafQuantity;
      gateLeafIndex++
    ) {

      const gateLeafStartX =
        gateBodyStartX +
        (
          gateLeafIndex *
          (
            gateLeafWidth +
            gateLeafVisualGap
          )
        );

      const gateLeafEndX = gateLeafStartX + gateLeafWidth;
      const postInnerLeft = gateLeafStartX + postWidth;
      const postInnerRight = gateLeafEndX - postWidth;
      const postInnerTop = gateStartY + postWidth;
      const postInnerBottom = gateBottomY - postWidth;
      const railInnerLeft = postInnerLeft + railWidth;
      const railInnerRight = postInnerRight - railWidth;
      const railInnerTop = postInnerTop + railWidth;
      const railInnerBottom = postInnerBottom - railWidth;

      const innerHeight =
        Math.max(
          0,
          railInnerBottom -
          railInnerTop
        );

      const topPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateStartY}
            ${gateLeafEndX},${gateStartY}
            ${postInnerRight},${postInnerTop}
            ${postInnerLeft},${postInnerTop}
          "
          fill="${fencingColour}"
        />
      `;

      const bottomPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateBottomY}
            ${gateLeafEndX},${gateBottomY}
            ${postInnerRight},${postInnerBottom}
            ${postInnerLeft},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const leftPost = `
        <polygon
          points="
            ${gateLeafStartX},${gateStartY}
            ${postInnerLeft},${postInnerTop}
            ${postInnerLeft},${postInnerBottom}
            ${gateLeafStartX},${gateBottomY}
          "
          fill="${fencingColour}"
        />
      `;

      const rightPost = `
        <polygon
          points="
            ${gateLeafEndX},${gateStartY}
            ${postInnerRight},${postInnerTop}
            ${postInnerRight},${postInnerBottom}
            ${gateLeafEndX},${gateBottomY}
          "
          fill="${fencingColour}"
        />
      `;

      const topRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerTop}
            ${postInnerRight},${postInnerTop}
            ${railInnerRight},${railInnerTop}
            ${railInnerLeft},${railInnerTop}
          "
          fill="${fencingColour}"
        />
      `;

      const bottomRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerBottom}
            ${postInnerRight},${postInnerBottom}
            ${railInnerRight},${railInnerBottom}
            ${railInnerLeft},${railInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const leftRail = `
        <polygon
          points="
            ${postInnerLeft},${postInnerTop}
            ${railInnerLeft},${railInnerTop}
            ${railInnerLeft},${railInnerBottom}
            ${postInnerLeft},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const rightRail = `
        <polygon
          points="
            ${postInnerRight},${postInnerTop}
            ${railInnerRight},${railInnerTop}
            ${railInnerRight},${railInnerBottom}
            ${postInnerRight},${postInnerBottom}
          "
          fill="${fencingColour}"
        />
      `;

      const postCornerDividerHtml = `
        <line
          x1="${gateLeafStartX}"
          y1="${gateStartY}"
          x2="${postInnerLeft}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafEndX}"
          y1="${gateStartY}"
          x2="${postInnerRight}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafStartX}"
          y1="${gateBottomY}"
          x2="${postInnerLeft}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${gateLeafEndX}"
          y1="${gateBottomY}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const railCornerDividerHtml = `
        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${railInnerLeft}"
          y2="${railInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerTop}"
          x2="${railInnerRight}"
          y2="${railInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerBottom}"
          x2="${railInnerLeft}"
          y2="${railInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerBottom}"
          x2="${railInnerRight}"
          y2="${railInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const postRailDividerHtml = `
        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${postInnerRight}"
          y2="${postInnerTop}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerBottom}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerLeft}"
          y1="${postInnerTop}"
          x2="${postInnerLeft}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${postInnerRight}"
          y1="${postInnerTop}"
          x2="${postInnerRight}"
          y2="${postInnerBottom}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      const singleGateLeafActualWidth =
        gateWidth /
        gateLeafQuantity;

      const availableActualWidth =
        Math.max(
          0,
          singleGateLeafActualWidth -
          (
            (
              postActualWidth +
              railActualWidth
            ) *
            2
          )
        );

      const maxSlatColumnsThatFit =
        Math.max(
          1,
          Math.floor(
            (
              availableActualWidth +
              gateGap
            ) /
            (
              slatActualWidth +
              gateGap
            )
          )
        );

      const visibleSlatColumns =
        Math.min(
          slatColumnsPerLeaf,
          maxSlatColumnsThatFit
        );

      const usedSlatWidth =
        (
          visibleSlatColumns *
          slatActualWidth
        ) +
        (
          Math.max(
            0,
            visibleSlatColumns -
            1
          ) *
          gateGap
        );

      const remainingWidth =
        Math.max(
          0,
          availableActualWidth -
          usedSlatWidth
        );

      const leftRemainingWidth =
        remainingWidth /
        2;

      const sideOffsetSvg =
        leftRemainingWidth *
        scale;

      let slatsHtml = '';

      for (
        let i = 0;
        i < visibleSlatColumns;
        i++
      ) {

        const slatX =
          railInnerLeft +
          sideOffsetSvg +
          (
            i *
            (
              slatSvgWidth +
              gateGapSvgWidth
            )
          );

        slatsHtml += `
          <rect
            x="${slatX}"
            y="${railInnerTop}"
            width="${slatSvgWidth}"
            height="${innerHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      gateHtml += `
        ${slatsHtml}
        ${topPost}
        ${bottomPost}
        ${leftPost}
        ${rightPost}
        ${topRail}
        ${bottomRail}
        ${leftRail}
        ${rightRail}
        ${postRailDividerHtml}
        ${postCornerDividerHtml}
        ${railCornerDividerHtml}
      `;
    }

    if (showGatePost) {

      const gatePostY = gateStartY - gatePostExtension;
      const gatePostHeight =
        gateDrawingHeight +
        (
          gatePostExtension *
          2
        );

      const leftGatePostX = gateBodyStartX - postWidth;
      const rightGatePostX = gateBodyStartX + singleGateDrawingWidth;

      gatePostsHtml += `
        <rect
          x="${leftGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${rightGatePostX}"
          y="${gatePostY}"
          width="${postWidth}"
          height="${gatePostHeight}"
          fill="${fencingColour}"
        />
      `;

      gatePostDividerHtml += `
        <line
          x1="${gateBodyStartX}"
          y1="${gatePostY}"
          x2="${gateBodyStartX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${rightGatePostX}"
          y1="${gatePostY}"
          x2="${rightGatePostX}"
          y2="${gatePostY + gatePostHeight}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;
    }

    dimensionsHtml +=
      createHorizontalDimension(
        gateBodyStartX,
        gateStartY,
        singleGateDrawingWidth,
        gateWidth
      );

    dimensionsHtml +=
      createVerticalDimension(
        gateBodyStartX,
        gateStartY,
        gateDrawingHeight,
        gateHeight
      );

    currentX +=
      singleGateDrawingWidth;

    if (showGatePost) {

      currentX +=
        postWidth *
        2;
    }

    if (
      gateIndex <
      gateQuantity -
      1
    ) {
      currentX += groupVisualGap;
    }
  }

  if (
    panelDetails.length > 0
  ) {
    currentX += groupVisualGap;
  }

  panelDetails.forEach(function (
    panel,
    panelGroupIndex
  ) {

    const panelWidth = Number(panel.width);
    const panelHeight = Number(panel.height);
    const panelQuantity = Number(panel.quantity) || 1;
    const panelGap = Number(panel.gap);
    const panelSlatColumns = Number(panel.productCount);
    const addPost = panel.addPost === true;

    if (
      !Number.isFinite(panelWidth) ||
      !Number.isFinite(panelHeight) ||
      !Number.isFinite(panelGap) ||
      !Number.isFinite(panelSlatColumns) ||
      panelWidth <= 0 ||
      panelHeight <= 0 ||
      panelQuantity <= 0
    ) {
      return;
    }

    const panelDrawingWidth = panelWidth * scale;
    const panelDrawingHeight = panelHeight * scale;
    const panelGapSvgWidth = panelGap * scale;
    const panelVisualGap = panelQuantity > 1
        ? panelVisualGapNoPost
        : 0;
    const panelGroupBodyWidth = panelDrawingWidth * panelQuantity;

    const panelGroupVisualGapWidth =
      panelQuantity > 1
        ? panelVisualGap *
          (
            panelQuantity -
            1
          )
        : 0;

    const panelGroupFullWidth = panelGroupBodyWidth + panelGroupVisualGapWidth;
    const panelFullDrawingHeight = panelDrawingHeight;
    const panelFullDrawingStartY =
      fullDrawingStartY +
      (
        maximumDrawingHeight -
        panelFullDrawingHeight
      ) /
      2;

    const panelStartY = panelFullDrawingStartY;
    const frameWidth = addPost
        ? postWidth
        : railWidth;

    const availableSlatActualWidth =
      addPost
        ? Math.max(
            0,
            panelWidth -
            (
              postActualWidth *
              2
            )
          )
        : panelWidth;

    const maxPanelSlatColumnsThatFit =
      Math.max(
        1,
        Math.floor(
          (
            availableSlatActualWidth +
            panelGap
          ) /
          (
            slatActualWidth +
            panelGap
          )
        )
      );

    const visiblePanelSlatColumns =
      Math.min(
        panelSlatColumns,
        maxPanelSlatColumnsThatFit
      );

    const usedSlatWidth =
      (
        visiblePanelSlatColumns *
        slatActualWidth
      ) +
      (
        Math.max(
          0,
          visiblePanelSlatColumns -
          1
        ) *
        panelGap
      );

    const remainingSlatWidth =
      Math.max(
        0,
        availableSlatActualWidth -
        usedSlatWidth
      );

    const sideOffsetSvg =
      (
        remainingSlatWidth /
        2
      ) *
      scale;

    const panelGroupStartX =
      currentX;

    for (
      let panelIndex = 0;
      panelIndex < panelQuantity;
      panelIndex++
    ) {

      const currentPanelStartX =
        panelGroupStartX +
        (
          panelIndex *
          (
            panelDrawingWidth + panelVisualGap
          )
        );

      const panelEndX = currentPanelStartX + panelDrawingWidth;

      const panelBottomY = panelStartY + panelDrawingHeight;

      const slatStartX =
        addPost
          ? currentPanelStartX +
            postWidth +
            sideOffsetSvg
          : currentPanelStartX +
            sideOffsetSvg;

      const slatStartY = panelStartY + frameWidth;
      const slatDrawingHeight =
        Math.max(
          0,
          panelDrawingHeight -
          (
            frameWidth *
            2
          )
        );

      let slatsHtml = '';

      for (
        let i = 0;
        i < visiblePanelSlatColumns;
        i++
      ) {

        const slatX = slatStartX +
          (
            i *
            (
              slatSvgWidth + panelGapSvgWidth
            )
          );

        slatsHtml += `
          <rect
            x="${slatX}"
            y="${slatStartY}"
            width="${slatSvgWidth}"
            height="${slatDrawingHeight}"
            fill="${fencingColour}"
          />
        `;
      }

      panelsHtml += `
        ${slatsHtml}

        <rect
          x="${currentPanelStartX}"
          y="${panelStartY}"
          width="${panelDrawingWidth}"
          height="${frameWidth}"
          fill="${fencingColour}"
        />

        <rect
          x="${currentPanelStartX}"
          y="${panelBottomY - frameWidth}"
          width="${panelDrawingWidth}"
          height="${frameWidth}"
          fill="${fencingColour}"
        />

        <rect
          x="${currentPanelStartX}"
          y="${panelStartY}"
          width="${frameWidth}"
          height="${panelDrawingHeight}"
          fill="${fencingColour}"
        />

        <rect
          x="${panelEndX - frameWidth}"
          y="${panelStartY}"
          width="${frameWidth}"
          height="${panelDrawingHeight}"
          fill="${fencingColour}"
        />

        <line
          x1="${currentPanelStartX + frameWidth}"
          y1="${panelStartY}"
          x2="${currentPanelStartX + frameWidth}"
          y2="${panelBottomY}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${panelEndX - frameWidth}"
          y1="${panelStartY}"
          x2="${panelEndX - frameWidth}"
          y2="${panelBottomY}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${currentPanelStartX}"
          y1="${panelStartY + frameWidth}"
          x2="${panelEndX}"
          y2="${panelStartY + frameWidth}"
          stroke="${dividerColour}"
          stroke-width="1"
        />

        <line
          x1="${currentPanelStartX}"
          y1="${panelBottomY - frameWidth}"
          x2="${panelEndX}"
          y2="${panelBottomY - frameWidth}"
          stroke="${dividerColour}"
          stroke-width="1"
        />
      `;

      if (addPost) {

        panelPostDividerHtml += `
          <line
            x1="${currentPanelStartX + postWidth}"
            y1="${panelStartY}"
            x2="${currentPanelStartX + postWidth}"
            y2="${panelBottomY}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${panelEndX - postWidth}"
            y1="${panelStartY}"
            x2="${panelEndX - postWidth}"
            y2="${panelBottomY}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${currentPanelStartX}"
            y1="${panelStartY + postWidth}"
            x2="${panelEndX}"
            y2="${panelStartY + postWidth}"
            stroke="${dividerColour}"
            stroke-width="1"
          />

          <line
            x1="${currentPanelStartX}"
            y1="${panelBottomY - postWidth}"
            x2="${panelEndX}"
            y2="${panelBottomY - postWidth}"
            stroke="${dividerColour}"
            stroke-width="1"
          />
        `;
      }
    }

    const panelDimensionStartX = panelGroupStartX;
    const panelDimensionWidth = panelGroupBodyWidth + panelGroupVisualGapWidth;
    const panelDimensionActualWidth = panelWidth * panelQuantity;
    const panelDimensionEndX = panelGroupStartX + panelGroupFullWidth;

    dimensionsHtml +=
      createHorizontalDimension(
        panelDimensionStartX,
        panelStartY,
        panelDimensionWidth,
        panelDimensionActualWidth
      );

    dimensionsHtml +=
      createVerticalDimensionRight(
        panelDimensionEndX,
        panelStartY,
        panelDrawingHeight,
        panelHeight
      );

    currentX +=panelGroupFullWidth;

    if (
      panelGroupIndex <
      panelDetails.length -
      1
    ) {

      currentX += groupVisualGap;
    }
  });

  container.innerHTML = `
    <svg
      width="${svgWidth}"
      height="${svgHeight}"
      viewBox="0 0 ${svgWidth} ${svgHeight}"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      style="display:block; margin:0 auto;"
    >

      ${gateHtml}
      ${gatePostsHtml}
      ${gatePostDividerHtml}
      ${panelsHtml}
      ${panelPostsHtml}
      ${panelPostDividerHtml}
      ${dimensionsHtml}

    </svg>
  `;

},


}; 